import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {

    static values = {
        uploadPhotosUrl: String,
        deletePhotoUrl: String,
    };

    declare readonly uploadPhotosUrlValue: string;
    declare readonly deletePhotoUrlValue: string;

    async uploadPhotos(e: Event): Promise<void> {
        const input = e.currentTarget as HTMLInputElement;
        const visitId = input.dataset.visitIdForUpload;
        if (!visitId || !input.files?.length) return;

        await this.doUploadPhotos(visitId, input.files);
        input.value = '';
    }

    private async doUploadPhotos(visitId: string, files: FileList): Promise<void> {
        const formData = new FormData();
        Array.from(files).forEach((file) => formData.append('photos[]', file));

        const url = this.uploadPhotosUrlValue.replace('/0/', '/' + visitId + '/');
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
        });
        const json = await response.json();
        if (!json.success) return;

        const rowContainer = this.element.querySelector(`[data-visit-photos-container="${visitId}"]`);
        if (!rowContainer) return;

        json.photos.forEach((photo: { id: number; url: string }) => {
            const thumb = this.buildPhotoThumb(photo.id, visitId, photo.url);
            const label = rowContainer.lastElementChild as HTMLElement | null;
            rowContainer.insertBefore(thumb, label);
        });
    }

    async deletePhoto(e: Event): Promise<void> {
        e.preventDefault();
        const btn = e.currentTarget as HTMLElement;
        const photoId = btn.dataset.photoId;
        if (!photoId) return;

        const url = this.deletePhotoUrlValue.replace('/0', '/' + photoId);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        const json = await response.json();
        if (!json.success) return;

        this.element.querySelectorAll(`[data-photo-id="${photoId}"]`).forEach((button) => {
            button.closest('.position-relative')?.remove();
        });
    }

    openPhotoPreview(e: Event): void {
        const img = e.currentTarget as HTMLImageElement;
        const src = img.dataset.src ?? img.src;
        const preview = document.getElementById('visitPhotoPreviewImg') as HTMLImageElement | null;
        if (!preview) return;

        preview.src = src;
        const modalEl = document.getElementById('visitPhotoPreviewModal');
        if (modalEl) {
            Modal.getOrCreateInstance(modalEl).show();
        }
    }

    private buildPhotoThumb(id: number, visitId: string, src: string): HTMLElement {
        const div = document.createElement('div');
        div.className = 'position-relative';
        div.style.cssText = 'width:48px;height:48px;';
        div.innerHTML = `
            <img src="${this.esc(src)}" class="rounded object-fit-cover border"
                 style="width:48px;height:48px;cursor:pointer;"
                 data-action="click->visit#openPhotoPreview"
                 data-src="${this.esc(src)}">
            <button type="button"
                    class="btn btn-danger btn-sm position-absolute top-0 end-0 p-0 lh-1"
                    style="width:16px;height:16px;font-size:10px;"
                    data-photo-id="${id}"
                    data-action="visit#deletePhoto">×</button>
        `;

        return div;
    }

    private esc(value: string): string {
        return value
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}
